<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <!--Button type="primary" class="add_coin" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('coin.coin')}}</Button-->
        </div>
        <Table border :columns="columns12" :data="coinList">
            <template slot-scope="{ row }" slot="is_open">
                <span v-if="row.is_open==1">{{$t('coin.already')}}{{$t('coin.open')}}</span>
                <span v-else>{{$t('coin.already')}}{{$t('coin.off')}}</span>
            </template>
            <template slot-scope="{ row }" slot="logo_image">
                <img :src="row.logo_image" style="width:32px;height:32px"></img>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <!--Button
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="showUserDetail(row.user_id)"
                    >{{$t('coin.edit')}}</Button-->
                    <Button
                        v-if="row.is_open == 0"
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.open')}}</Button>
                    <Button
                        v-if="row.is_open == 1"
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.off')}}</Button>
                </div>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>

        <Modal
            v-model="showOkModal"
            :title="$t('coin.confirmOk')"
            @on-ok="change_staust(1)"
            @on-cancel="showOkModal=false"
        >
        </Modal>
        <Modal
            v-model="showCancelModal"
            :title="$t('coin.confirmCancel')"
            @on-ok="change_staust(0)"
            @on-cancel="showCancelModal=false"
        >
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            modalItem: {},
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            showOkModal: false,
            showCancelModal: false,
            columns12: [
                {
                    title: "ID",
                    width: 80,
                    key: "id",
                },
                {
                    title: this.$i18n.t('coin.pair'),
                    width: 250,
                    key: "pair_name",
                },
                {
                    title: this.$i18n.t('coin.name'),
                    width: 250,
                    key: "nickname"
                },
                {
                    title: this.$i18n.t('coin.jiaoyidui'),
                    width: 250,
                    key: "coinname"
                },
                {
                    title: this.$i18n.t('coin.icon'),
                    width: 250,
                    key: "logo_image",
                    slot: "logo_image"
                },
                {
                    title: this.$i18n.t('coin.status'),
                    width: 250,
                    key: "is_open",
                    slot:"is_open"
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 400,
                    align: "center",
                    fixed:"right"
                }
            ],
            coinList: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.coin_pair, {
                page: this.currentPage,
                search: this.search
            }).then(res => {
                if (res.data) {
                    this.coinList = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        openModal(row) {
          this.modalItem = row;
          if(this.modalItem.is_open == 1){
            this.showCancelModal = true;
          }else{
            this.showOkModal = true;
          }
        },
        change_staust(status) {
          this.$post(this.$path.change_status, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_coin {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%;
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/system/coin.vue